"use client";

import { usePathname } from "next/navigation";
import { MarketingNavigation } from "@/components/navigation/MarketingNavigation";
import { StandardNavigation } from "@/components/navigation/StandardNavigation";

export function TopNavigationWrapper() {
  const pathname = usePathname();

  const customRouts = ["/", "/features", "/checkout"] 

  if(customRouts.includes(pathname)) {
    return (<MarketingNavigation/>)
  }

  return <StandardNavigation />;
}
